import { usePermissions } from '@/hooks/usePermissions'
import { useTranslation } from 'react-i18next'

import { Box, Toggle } from '@hivewatch/dark'

interface DarkResolveToggleIProps {
  colorScheme: 'dark' | 'light'
  isReal: boolean
  isLoading: boolean
  onChange: (isReal: boolean) => void
}

export const DarkResolveToggle = ({
  colorScheme,
  isReal,
  isLoading,
  onChange,
}: DarkResolveToggleIProps) => {
  const { t } = useTranslation()
  const { shouldEnableIncidentActions } = usePermissions()
  const isDisabled = !shouldEnableIncidentActions || isLoading

  return (
    <Box alignItems='center' display='flex' gap='8px'>
      <Toggle
        aria-label='Toggle real or false'
        colorScheme={colorScheme}
        data-testid='incidentDrawer_resolve_setRealFalseToggle'
        disabled={isDisabled}
        isOn={isReal}
        onChange={(val) => onChange(val)}
      />
      <Box
        as='span'
        color={
          colorScheme === 'light' ? 'light.text.secondary' : 'text.secondary'
        }
        data-testid='ResolveLabelValue:title'
        fontFamily="'Soehne', sans-serif"
        fontSize='12px'
        fontWeight='400'
        lineHeight='16px'
      >
        {isReal
          ? t('incidents:incident_drawer_resolve_real')
          : t('incidents:incident_drawer_resolve_false')}
      </Box>
    </Box>
  )
}
